import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../api/api.service';
import { RATING_ENDPOINTS } from '../../api/endpoints/rating.endpoints';

@Injectable({
  providedIn: 'root',
})
export class RatingService {
  private api = inject(ApiService);

  createQcSurvey(survey): Observable<any> {
    return this.api
      .post<any>(RATING_ENDPOINTS.V1.QUALITY_CONTROL_REVIEW, survey)
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  getQualityControlReview(orderID) {
    return this.api
      .get<any>(RATING_ENDPOINTS.V1.QUALITY_CONTROL_REVIEW_BY_ORDER(orderID))
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  updateQualityControlReview(orderID, survey) {
    return this.api
      .put<any>(
        RATING_ENDPOINTS.V1.QUALITY_CONTROL_REVIEW_BY_ORDER(orderID),
        survey,
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  getCustomerReview(orderID) {
    return this.api
      .get<any>(RATING_ENDPOINTS.V1.ADMIN_CUSTOMER_REVIEW(orderID))
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  updateCustomerReview(orderID, survey) {
    return this.api
      .put(RATING_ENDPOINTS.V1.ADMIN_CUSTOMER_REVIEW(orderID), survey)
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  getInspectorReview(orderID) {
    return this.api
      .get<any>(RATING_ENDPOINTS.V1.INSPECTOR_OVERALL_RATING(orderID))
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  canAddCustomerReview(orderID) {
    return this.api
      .get<any>(RATING_ENDPOINTS.V1.ADMIN_CUSTOMER_REVIEW_CAN_ADD(orderID))
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  canAddQCReview(orderID) {
    return this.api
      .get<any>(RATING_ENDPOINTS.V1.QUALITY_CONTROL_REVIEW_CAN_ADD(orderID))
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  hideCustomerReview(orderID) {
    return this.api
      .delete<any>(RATING_ENDPOINTS.V1.ADMIN_CUSTOMER_REVIEW(orderID))
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }

  hideQCReview(orderID) {
    return this.api
      .delete<any>(RATING_ENDPOINTS.V1.QUALITY_CONTROL_REVIEW_BY_ORDER(orderID))
      .pipe(
        map((data: any) => {
          return data;
        }),
      );
  }
}
